import { render, staticRenderFns } from "./main-slides.vue?vue&type=template&id=34cdde0f&scoped=true&"
import script from "./main-slides.vue?vue&type=script&lang=js&"
export * from "./main-slides.vue?vue&type=script&lang=js&"
import style0 from "./main-slides.vue?vue&type=style&index=0&id=34cdde0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cdde0f",
  null
  
)

export default component.exports